import { SkeduloPlatformGlobals } from './types'

/**
 * Safely sets partials of the SkeduloPlatform global object on the Window.
 *
 * @param globalsToMerge Some or all of the new values to set on the SkeduloPlatform global object
 */
export const setPlatformGlobals = (
  globalsToMerge: Partial<SkeduloPlatformGlobals> = {},
) => {
  if (!window.SkeduloPlatform) {
    window.SkeduloPlatform = globalsToMerge
    return
  }

  const keysToUpdate = Object.keys(
    globalsToMerge,
  ) as (keyof SkeduloPlatformGlobals)[]

  keysToUpdate.forEach((globalKey) => {
    window.SkeduloPlatform = {
      ...window.SkeduloPlatform,
      [globalKey]: globalsToMerge[globalKey],
    }
  })
}

export const getPlatformGlobals = (): SkeduloPlatformGlobals => {
  return window.SkeduloPlatform || {}
}

export const getPlatformGlobal = <T extends keyof SkeduloPlatformGlobals>(
  globalKey: T,
): SkeduloPlatformGlobals[T] => {
  return getPlatformGlobals()[globalKey]
}
